import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {Support} from "../../../shared/interface/support";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {CorporationService} from "../../../shared/services/corporation.service";

@Component({
  selector: 'app-all-corporation-list',
  templateUrl: './all-corporation-list.component.html',
  styleUrls: ['./all-corporation-list.component.scss']
})
export class AllCorporationListComponent implements OnDestroy, AfterViewInit {

  @Input() serviceTypeKeys?: string = null;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  supports: Support[] = [];
  totalData = 0;
  displayedColumns: string[] = ['id', 'status', 'reasonForRefusal', 'partner', 'ofwca', 'productType', 'createdAt', 'user', 'policyNumber'];
  userPermissions: ReplaySubject<UserPermissions>;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private corporationService: CorporationService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.corporationService.getSupportListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<Support>) => {
          this.supports = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }
  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      typeOfActivity: 'int',
      status: 'int',
      ofwca: 'string',
      partner: 'string',
      username: 'string',
      gte$createdAt: 'date',
      reasonForRefusal: 'string',
      contains$policyNumber: 'string',
    }, filters);
  }


  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.serviceTypeKeys) {
      filters.serviceTypeKeys = this.serviceTypeKeys;
    }

    return filters;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
  loadListData(): void {
    this.corporationService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
    );
  }

  downloadReport(): void {
    this.corporationService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  ngAfterViewInit(): void {
    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) =>
          prev?.url === curr?.url &&
          prev?.params?.page === curr?.params?.page &&
          prev?.params?.pageSize === curr?.params?.pageSize
        ),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state?.params || {});

        if (this.paginator.pageIndex !== (state?.params?.page || 0)) {
          this.paginator.pageIndex = state?.params?.page || 0;
        }
        if (this.paginator.pageSize !== (state?.params?.pageSize || 10)) {
          this.paginator.pageSize = state?.params?.pageSize || 10;
        }

        this.loadListData();
      });

    this.activatedRoute.data
      .pipe(
        first(),
        takeUntil(this.destroyed$)
      )
      .subscribe((data: any) => {
        this.serviceTypeKeys = this.serviceTypeKeys ?? data.serviceTypeKeys ?? null;
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((event: PageEvent) => {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path,
          this.filterService.parseFiltersToQueryParams({
            page: event.pageIndex,
            pageSize: event.pageSize,
            ...this.filtersForm.value
          })
        ]);
      });
  }
}
